import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IconCoinBlue from '../../../assets/iconCoinBlue';
import IconArrowOrder from '../../../assets/IconArrowOrder';
const CategoryOrder = ({ setSortBy, setSortOrder, value, sortOrder }) => {
    const handleClick = (event) => {
        event.preventDefault(); // Prevent any default actions
        toggleOrder(value);
    };
    const toggleOrder = (value = "string") => {
        setSortBy(value);
        setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : (prevOrder === 'desc' ? "" : 'asc')));
    };
    return (_jsx("div", { className: "categories__item categories__item--order", "category-tittle": "priceorder", onClick: handleClick, children: _jsxs("div", { className: "categories__item-inner", children: [_jsx("div", { className: "categories__image categories__image--order", children: _jsx(IconCoinBlue, {}) }), _jsxs("div", { className: "category-order", children: [_jsx("span", { className: `order-desc ${sortOrder === 'asc' ? 'active' : ''}`, children: _jsx(IconArrowOrder, {}) }), _jsx("span", { className: `order-acs ${sortOrder === 'desc' ? 'active' : ''}`, children: _jsx(IconArrowOrder, {}) })] })] }) }));
};
export default CategoryOrder;
